import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { handleMonthInput, MonthPicker } from '@common/datePicker';
import styles from '@components/profile/profileOverlay/overlays/career/career.module.scss';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

type StartDateProps = UseControllerProps & {
  readonly?: boolean;
};
const StartDate = (props: StartDateProps) => {
  const { field, fieldState } = useController(props);

  const selected = field.value ? new Date(field.value) : null;
  const handleChange = (date: Date | null) => {
    if (!date) return;
    field.onChange(DateFormat.format(date, 'yyyy-MM'));
  };

  return (
    <div className={cx('periodWrap')}>
      <MonthPicker
        selected={selected}
        onChange={handleChange}
        onChangeRaw={handleMonthInput}
        className={cx(
          'periodInput',
          { error: fieldState.invalid },
          { complete: field.value },
          { readonly: props.readonly },
        )}
        placeholderText="연도. 월"
        maxDate={new Date('9999-12')}
        readOnly={props.readonly}
      />
      {fieldState.invalid && <div className={cx('errorMessage')}>입사 일자를 입력해 주세요.</div>}
    </div>
  );
};

export default StartDate;
